const menuItems = [
    { id: 'createShortcut', text: 'Add to Shortcuts' },
    { id: 'deleteShortcut', text: 'Delete Shortcut' }
  ];
  export default {
    getMenuItems() {
      return menuItems;
    }
};